import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import axios, { parseAxiosError } from '@/portainer/services/axios';

import { Application } from '../ListView/ApplicationsDatatable/types';

import { queryKeys } from './query-keys';

export function useApplicationResource(
  environmentId: EnvironmentId,
  namespace: string,
  name: string,
  resourceType?: string,
  options?: { autoRefreshRate?: number; yaml?: boolean; enabled?: boolean }
): UseQueryResult<Application> {
  return useQuery(
    queryKeys.ApplicationResource(environmentId, namespace, name, resourceType),
    () => getApplicationResource(environmentId, namespace, name, resourceType),
    {
      enabled:
        !!environmentId && !!namespace && !!name && options?.enabled !== false,
      ...withGlobalError('Unable to retrieve application'),
      refetchInterval() {
        return options?.autoRefreshRate ?? false;
      },
    }
  );
}

async function getApplicationResource(
  environmentId: EnvironmentId,
  namespace: string,
  name: string,
  resourceType?: string
): Promise<Application> {
  try {
    const { data } = await axios.get<Application>(
      `/kubernetes/${environmentId}/namespaces/${namespace}/applications/${name}`,
      {
        params: resourceType ? { resourceType } : {},
      }
    );
    return data;
  } catch (err) {
    throw parseAxiosError(err);
  }
}
